import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { Printer } from "lucide-react";
import { useParams } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const MedicalQrcodeCerteficate = () => {

  const location = useLocation();
  const { patientId } = useParams();

  const [hpi, setHpi] = useState([]);
  const [labResults, setLabResults] = useState([]);
  const [imaging, setImaging] = useState([]);
  const [physicalExam, setPhysicalExam] = useState([]);
  const [patientDetails, setPatientDetails] = useState(null);
  const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const now = new Date();
  let years = now.getFullYear() - birthDate.getFullYear();
  let months = now.getMonth() - birthDate.getMonth();
  let days = now.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    days += new Date(now.getFullYear(), now.getMonth(), 0).getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  if (years < 5) {
    return `${years > 0 ? `${years} yr${years > 1 ? 's' : ''}, ` : ''}${months} mo${months > 1 ? 's' : ''}, ${days} day${days > 1 ? 's' : ''}`;
  }

  return `${years} years`;
};

  const [systemData, setSystemData] = useState({
    phoneNumber: '',
    tinNumber: '',
    address: '',
    email: '',
    titleAmharic: '',
    titleEnglish: '',
  });

  const getPhotoUrl = (photoPath) => {
  if (!photoPath) return null;
  return `${BASE_URL}${photoPath}`;
};
  
  useEffect(() => {
  // Fetch the current settings from the backend
  const fetchSettings = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/setting/get-settings`);
    setSystemData(response.data);
  } catch (error) {
    console.error(error);
  }
  };
  
  fetchSettings();
  }, []);

   useEffect(() => {
    fetch(`${BASE_URL}/patient/view-all-patients-based-on-ward/${patientId}`)
      .then((res) => res.json())
      .then((data) => {
        setPatientDetails(data);
      })
      .catch((err) => console.error("Error fetching patient details:", err));
  }, [patientId]);

    useEffect(() => {

    if (!patientId) return;

    const fetchData = async () => {
      try {
        const res = await fetch(`${BASE_URL}/client/${patientId}/medical-data`);
        const data = await res.json();

        setHpi(data.hpi || []);
        setLabResults(data.lab_results || []);
        console.log(data.lab_result);
        setImaging(data.imaging || []);
        setPhysicalExam(data.physical_exam || []);
      } catch (e) {
        console.error("Fetch error:", e);
      }
    };

    fetchData();
  }, [patientId]);

  return (
    <div className="min-h-[80vh] w-full md:min-h-screen bg-gray-200">
    <div className="px-6 mx-auto bg-white border border-black rounded-lg shadow-md print-invoice">
    
{/* ===============================
    PREMIUM HEADER SECTION
================================== */}
<div className="w-full pb-3 mb-1 flex text-white bg-blue-400 justify-between items-center 
  border-b-4 border-blue-900 rounded-md shadow-md py-3 print-header">

  {/* LEFT — Amharic + Photo */}
  <div className="flex items-center gap-4 w-1/3">
    {/* Patient Photo */}
    {patientDetails?.photo_url && (
      <div className="w-24 h-24 border-2 border-gray-300 rounded-full overflow-hidden shadow-md">
        <img
          src={getPhotoUrl(patientDetails.photo_url)}
          alt={`${patientDetails.name}'s Photo`}
          className="w-full h-full object-cover"
        />
      </div>
    )}

    <div className="leading-tight">
      <h2 className="text-xl font-bold">{systemData.titleAmharic}</h2>
      <p className="text-sm">📞 {systemData.phoneNumber}</p>
    </div>
  </div>

  {/* CENTER LOGO */}
  <div className="w-1/3 flex justify-center">
    <img
      src="/assets/hiywot_logo.jpg"
      alt="Clinic Logo"
      className="h-24 w-24 object-cover rounded-full drop-shadow-md"
    />
  </div>

  {/* RIGHT — English */}
  <div className="leading-tight text-right w-1/3">
    <h2 className="text-xl font-bold">{systemData.titleEnglish}</h2>
    <p className="text-sm"><strong>TIN:</strong> {systemData.tinNumber}</p>
    <p className="text-sm"><strong>Email:</strong> {systemData.email}</p>
    <p className="text-sm"><strong>Address:</strong> {systemData.address}</p>
  </div>
</div>

<h1 className="text-center text-xl font-bold text-blue-900 tracking-wide">
  MEDICAL CERTIFICATE
</h1>

<div className="text-center">
{/* ================================
    3-COLUMN INLINE PATIENT INFO TABLE
=================================== */}
{patientDetails ? (
<table className="w-full border border-gray-300 text-sm rounded-lg overflow-hidden shadow">
  <tbody className="divide-y divide-gray-300">

    {/* Row 1 */}
    <tr className="bg-gray-50">
      <td className="px-3 py-2">
        <span className="">Name: </span>
        {patientDetails.name} {patientDetails.fname} {patientDetails.gfname}
      </td>
      <td className="px-3 py-2">
        <span className="">Age: </span>
        {patientDetails.age} yrs
      </td>

      <td className="px-3 py-2">
        <span className="">Gender: </span>
        {patientDetails.sex}
      </td>
    </tr>

    {/* Row 2 */}
    <tr>
      <td className="px-3 py-2">
        <span className="">MRN: </span>
        {patientDetails.mrn}
      </td>

      <td className="px-3 py-2">
        <span className="">Height: </span>
        {patientDetails.height || "—"}
      </td>

      <td className="px-3 py-2">
        <span className="">Weight: </span>
        {patientDetails.weight || "—"}
      </td>
    </tr>

    {/* Row 3 */}
    <tr className="bg-gray-50">
      <td className="px-3 py-2">
        <span className="">Profession: </span>
        {patientDetails.profession || "—"}
      </td>

      <td className="px-3 py-2">
        <span className="">Marital Status: </span>
        {patientDetails.marital_status || "—"}
      </td>

      <td className="px-3 py-2">
        <span className="">Place of Issue: </span>
        {patientDetails.place_issue || "—"}
      </td>
    </tr>

    {/* Row 4 */}
    <tr>
      <td className="px-3 py-2">
        <span className="">Destination: </span>
        {patientDetails.destination || "—"}
      </td>

      <td className="px-3 py-2">
        <span className="">Nationality: </span>
        {patientDetails.nationality || "—"}
      </td>

      <td className="px-3 py-2">
        <span className="">Passport No: </span>
        {patientDetails.passport_number || "—"}
      </td>
    </tr>

    {/* Row 5 */}
    <tr className="bg-gray-50">
      <td className="px-3 py-2" colSpan={3}>
        <span className="">Labor ID: </span>
        {patientDetails.labor_number || "—"}
      </td>
    </tr>
  </tbody>
</table>
) : (
  <p>Loading patient details...</p>
)}
    </div>
      <div className="h-1 w-full rounded-full mb-4 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500" />

      {/* =========================
            HPI / HISTORY
        ==========================*/}
        <h2 className="font-semibold text-lg">History</h2>
        <table className="w-full border mt-2 mb-4">
          <thead className="bg-gray-200">
            <tr>
              <th className="border px-2 py-1">History</th>
            </tr>
          </thead>
          <tbody>
            {hpi.map((row, i) => (
              <tr key={i}>
                <td className="border px-2 py-1">{row.chief_complaint}</td>
              </tr>
            ))}
          </tbody>
        </table>
         {/* =========================
            PHYSICAL EXAM
        ==========================*/}
        <h2 className="font-semibold text-lg">Physical Examination</h2>
        {physicalExam.length > 0 && (
          <table className="w-full border mt-2 mb-4">
            <tbody>
              <tr><th className="border px-2 py-1 w-40">General Appearance</th><td className="border px-2 py-1">{physicalExam[0].general_survey}</td></tr>
              <tr><th className="border px-2 py-1">Vital Signs</th><td className="border px-2 py-1">{physicalExam[0].vital_sign}</td></tr>
              <tr><th className="border px-2 py-1">HEENT</th><td className="border px-2 py-1">{physicalExam[0].heent}</td></tr>
              <tr><th className="border px-2 py-1">Chest</th><td className="border px-2 py-1">{physicalExam[0].chest}</td></tr>
              <tr><th className="border px-2 py-1">CVS</th><td className="border px-2 py-1">{physicalExam[0].cvs}</td></tr>
              <tr><th className="border px-2 py-1">Abdomen</th><td className="border px-2 py-1">{physicalExam[0].abdomen}</td></tr>
              <tr><th className="border px-2 py-1">GU</th><td className="border px-2 py-1">{physicalExam[0].gu}</td></tr>
              <tr><th className="border px-2 py-1">Derm</th><td className="border px-2 py-1">{physicalExam[0].derm}</td></tr>
              <tr><th className="border px-2 py-1">MSE</th><td className="border px-2 py-1">{physicalExam[0].mse}</td></tr>
            </tbody>
          </table>
        )}
        {/* =========================
            LAB RESULTS
        ==========================*/}
        <h2 className="font-semibold text-lg">Laboratory</h2>
        <table className="w-full border mt-2 mb-4">
          <thead className="bg-gray-200">
            <tr>
              <th className="border px-2 py-1">Type of Investigation</th>
              <th className="border px-2 py-1">Result</th>
            </tr>
          </thead>
          <tbody>
            {labResults.map((lab, i) => (
              <tr key={i}>
                <td className="border px-2 py-1">{lab.test_name}</td>
                <td className="border px-2 py-1">{lab.lab_result}</td>
              </tr>
            ))}
          </tbody>
        </table>

      {/* =========================
            IMAGING RESULTS
        ==========================*/}
        <h2 className="font-semibold text-lg">Imaging</h2>
        <table className="w-full border mt-2 mb-4">
          <thead className="bg-gray-200">
            <tr>
              <th className="border px-2 py-1">Imaging</th>
              <th className="border px-2 py-1">Result</th>
            </tr>
          </thead>
          <tbody>
            {imaging.map((img, i) => (
              <tr key={i}>
                <td className="border px-2 py-1">{img.ultrasound_type}</td>
                <td className="border px-2 py-1">{img.result}</td>
              </tr>
            ))}
          </tbody>
        </table>

    </div>
    </div>
  );
};

export default MedicalQrcodeCerteficate;
